import { TasksKanbanColumn } from "./TasksKanbanColumn";
import { KanbanStage, KanbanTask } from "./types";

interface TasksDraggableKanbanBoardProps {
  stages: KanbanStage[];
  tasksByStage: Record<string, KanbanTask[]>;
  onTaskDrop: (taskId: string, targetColumnId: string) => void;
  statusConfig?: Record<string, {
    color: string;
    bgColor: string;
    borderColor: string;
    headerBg: string;
    headerText: string;
    dotColor: string;
  }>;
  onTaskUpdated?: () => void;
}

export const TasksDraggableKanbanBoard = ({ 
  stages, 
  tasksByStage,
  onTaskDrop,
  statusConfig,
  onTaskUpdated
}: TasksDraggableKanbanBoardProps) => {
  
  const handleDragStart = (e: React.DragEvent, taskId: string, sourceColumnId: string) => {
    e.dataTransfer.setData("taskId", taskId);
    e.dataTransfer.setData("sourceColumnId", sourceColumnId);
  };
  
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  
  const handleDrop = (e: React.DragEvent, targetColumnId: string) => {
    e.preventDefault();
    const taskId = e.dataTransfer.getData("taskId");
    const sourceColumnId = e.dataTransfer.getData("sourceColumnId");
    
    if (sourceColumnId !== targetColumnId) {
      onTaskDrop(taskId, targetColumnId);
    }
  };
  
  return (
    <div className="flex space-x-6 overflow-x-auto pb-6 px-2">
      {stages.map(stage => (
        <TasksKanbanColumn
          key={stage.id}
          id={stage.id}
          title={stage.name}
          tasks={tasksByStage[stage.id] || []}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          statusConfig={statusConfig}
          onTaskUpdated={onTaskUpdated}
        />
      ))}
    </div>
  );
};
